import { useState, useEffect, useRef } from 'react';

export default function useComponentVisible<T extends HTMLElement>(
  initialIsVisible: boolean
) {
  const [isComponentVisible, setIsComponentVisible] =
    useState(initialIsVisible);

  const ref = useRef<T>(null);

  const handleComponentVisible = () => {
    setIsComponentVisible(prev => !prev);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (ref.current && !ref.current.contains(<Node>event!.target)) {
      setIsComponentVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, { capture: true });
    return () => {
      document.removeEventListener('click', handleClickOutside, {
        capture: true,
      });
    };
  }, []);

  return { ref, isComponentVisible, handleComponentVisible };
}
